<template>
	<div>
		<div
			class="modal fade"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-focus="false"
		>
			<div class="modal-dialog vld-parent" role="document">
				<div class="modal-content">
					<div class="private-chef-spotlight">
						<button
							type="button"
							class="modal-close"
							@click="close"
							aria-label="Close"
						>
							<i class="sk-icon-times"></i>
						</button>
					</div>
					<div class="modal-body">
						<div class="modal-inner-content">
							<h1 class="modal-title">
								{{ title }}
							</h1>
							<span class="modal-subtitle">
								Enjoy an exclusive $10 and $12 menu
								<br />
								prepared by local chefs
							</span>
							<div
								class="slots-row"
								v-for="weekday in eventWeekdays"
								:key="weekday"
							>
								<h2 class="slot-divider">
									{{ weekday }}
								</h2>
								<div class="slot-button-row">
									<button
										v-for="event in eventWeekdaysDict[
											weekday
										]"
										:key="event.id"
										class="
											button button-primary
											slot-button
										"
										@click="clickCta(event)"
									>
										{{ deliveryTime(event) }}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-close {
	position: absolute;
	top: 15px;
	right: 5px;
}

.modal-close i {
	color: var(--gR-white);
}

.private-chef-spotlight {
	height: 226px;
	border-top-right-radius: 5px;
	border-top-left-radius: 5px;
	background: linear-gradient(
			180deg,
			rgba(16, 16, 16, 0.46) 0%,
			rgba(145, 145, 145, 0) 100%
		),
		url("/images/private-chef-spotlight.jpg");
	background-position: center;
	background-size: cover;
}

.modal-body {
	justify-content: flex-start;
}

.modal-title {
	font-size: 24px;
	margin-top: 20px;
	text-align: center;
}

.modal-subtitle {
	font-size: 14px;
	color: var(--sk-grey3);
	text-align: center;
	margin-bottom: 26px;
}

.modal-inner-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
}

.modal-inner-content .button {
	flex-shrink: 0;
}

.slot-divider {
	width: 100%;
	font-style: normal;
	font-weight: 600;
	font-size: 12px;
	line-height: 15px;
	align-items: center;
	text-align: center;
	color: var(--gR-base-90);
}

.slot-button {
	margin-bottom: 10px !important;
	flex: 1;
}

.slot-button + .slot-button {
	margin-left: 5px !important;
}

.slots-row {
	width: 100%;
}

.slot-button-row {
	display: flex;
}

@media only screen and (max-width: 400px) {
	.modal-title {
		margin-top: 0;
	}
}
</style>

<script>
import { ExperimentType } from "@/enums/ExperimentType"
import { EventStatus } from "@reef-os/utils/enums/eventStatus"
import moment from "moment"

export default {
	name: "MultiDeliverySlotEventModal",
	data: function () {
		return {
			params: {}
		}
	},
	mounted: function () {},
	computed: {
		eventWeekdaysDict() {
			var retVal = {}
			if (this.params.eventIds) {
				const eventIds = this.params.eventIds.split(",")
				eventIds.forEach((eventId) => {
					let event = this.$store.state.businessEvents
						? this.$store.state.businessEvents.find(
								(busEvent) =>
									busEvent.id == eventId &&
									busEvent.status == EventStatus.PREORDER
						  )
						: null
					if (event != null) {
						let eventWeekday = moment(
							event.end_date,
							"YYYY-MM-DD"
						).format("dddd, MMM Do")
						if (!retVal[eventWeekday]) {
							retVal[eventWeekday] = []
						}
						retVal[eventWeekday].push(event)
					}
				})
				Object.keys(retVal).forEach((key) => {
					retVal[key].sort((a, b) => {
						return (
							moment(a.eventDate, "MMMM Do h:mm a").toDate() -
							moment(b.eventDate, "MMMM Do h:mm a").toDate()
						)
					})
				})
			}
			return retVal
		},
		eventWeekdays() {
			return Object.keys(this.eventWeekdaysDict).sort((a, b) => {
				return (
					moment(a, "dddd, MMM Do").toDate() -
					moment(b, "dddd, MMM Do").toDate()
				)
			})
		},
		title() {
			return "Introducing Home-Style Meals"
		},
		eventRestaurantName() {
			if (this.eventWeekdays && this.eventWeekdays.length > 0) {
				let restaurantId =
					this.eventWeekdaysDict[this.eventWeekdays[0]][0]
						.restaurant_id
				if (
					this.$store.state.restaurants &&
					this.$store.state.restaurants != null &&
					this.$store.state.restaurants[restaurantId]
				) {
					return this.$store.state.restaurants[restaurantId].name
				} else {
					return this.eventWeekdaysDict[this.eventWeekdays[0]][0].name
				}
			}
		}
	},
	methods: {
		open() {
			let isModalOpen = $(this.$refs.modal).is(":visible")
			if (isModalOpen) {
				return
			}
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Experiment Modal CTA Opened",
				data: {
					type: ExperimentType.MULTIPLE_EVENT_TIMES
				}
			})
			this.params = this.$route.query
			$(this.$refs.modal).modal("show")
		},
		deliveryTime(event) {
			return event != null
				? moment(event.end_time, "HH:mm:ss").format("h:mm a")
				: ""
		},
		clickCta(event) {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Experiment Modal CTA Clicked",
				data: {
					type: ExperimentType.MULTIPLE_EVENT_TIMES
				}
			})
			this.$router.push({
				path: `/${this.$route.params.slug}/menu/event/${event.id}`
			})
			this.close()
		},
		close() {
			this.params = {}
			$(this.$refs.modal).modal("hide")
		}
	}
}
</script>
